<template>
  <section class="section is-fullheight animated preFadeInUp fadeInUp">
    <div class="container">
      <div
        id="success-overlay"
        class="modal modal-lg modal-success"
        v-bind:class="{
          'is-active': userDataActiveModal,
        }"
      >
        <div class="modal-background scaleInCircle"></div>
        <div class="modal-content scaleIn">
          <div class="flex-card simple-shadow" style="margin: 0px">
            <header class="modal-card-head">
              <p class="modal-card-title p-20">
                <b>تعديل معلومات المستخدم الشخصية</b>
              </p>
            </header>
            <div
              class="card-body"
              style="padding-right: 0px; padding-left: 0px; padding-top: 0px"
            >
              <div class="content">
                <section
                  class="modal-card-body"
                  style="padding-right: 40px; padding-left: 40px"
                >
                  <div class="animated preFadeInUp fadeInUp">
                    <!-- <div>
                      الرجاء إستكمال البيانات التالية قبل التسجيل في منظومة مصرف
                      ليبيا المركزي لغرض شحن بطاقة الأغراض الشخصية
                    </div> -->
                    <div>
                      <div class="columns">
                        <div class="column is-6">
                          <b-field
                            label="رقم جواز السفر"
                            :type="{ 'is-danger': errors.has('passportNo') }"
                            :message="errors.first('passportNo')"
                          >
                            <b-input
                              type="text"
                              size="is-medium"
                              custom-class="has-text-centerd"
                              v-model="requestInfoBasicData.passportNo"
                              name="passportNo"
                              v-validate="'required'"
                              placeholder="ادخل رقم جواز السفر"
                              expanded
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <v-date-picker
                            v-model="
                              requestInfoBasicData.passportExpirationDate
                            "
                            locale="ar"
                            :popover="{
                              placement: 'bottom',
                              visibility: 'click',
                            }"
                            :first-day-of-week="1"
                          >
                            <b-field
                              label="تاريخ انتهاء صلاحية جواز السفر "
                              size="is-medium"
                              :class="{
                                'is-danger': errors.has(
                                  'passportExpirationDate'
                                ),
                              }"
                            >
                              <b-input
                                type="text"
                                class="is-medium has-background-white"
                                :value="
                                  $root.dateformat(
                                    requestInfoBasicData.passportExpirationDate
                                  )
                                "
                                v-validate="'required'"
                                placeholder="تاريخ انتهاء صلاحية جواز السفر "
                                name="passportExpirationDate"
                                readonly
                                expanded
                              ></b-input>
                            </b-field>
                          </v-date-picker>
                          <span
                            v-show="errors.has('passportExpirationDate')"
                            class="help is-danger is-centered"
                            >{{ errors.first("passportExpirationDate") }}</span
                          >
                        </div>
                      </div>
                      <div class="columns">
                        <div class="column is-6">
                          <b-field
                            label="الإسم الأول"
                            :type="{ 'is-danger': errors.has('firstName') }"
                            :message="errors.first('firstName')"
                          >
                            <b-input
                              type="text"
                              size="is-medium"
                              custom-class="has-text-centerd"
                              v-model="requestInfoBasicData.firstName"
                              name="firstName"
                              v-validate="'required'"
                              placeholder="ادخل الإسم الأول"
                              expanded
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label="إسم الأب"
                            :type="{ 'is-danger': errors.has('fatherName') }"
                            :message="errors.first('fatherName')"
                          >
                            <b-input
                              type="text"
                              size="is-medium"
                              custom-class="has-text-centerd"
                              v-model="requestInfoBasicData.fatherName"
                              name="fatherName"
                              v-validate="'required'"
                              placeholder="ادخل إسم الأب"
                              expanded
                            ></b-input>
                          </b-field>
                        </div>
                      </div>
                      <div class="columns">
                        <div class="column is-6">
                          <b-field
                            label="إسم الجد"
                            :type="{
                              'is-danger': errors.has('grandFatherName'),
                            }"
                            :message="errors.first('grandFatherName')"
                          >
                            <b-input
                              type="text"
                              size="is-medium"
                              custom-class="has-text-centerd"
                              v-model="requestInfoBasicData.grandFatherName"
                              name="grandFatherName"
                              v-validate="'required'"
                              placeholder="ادخل إسم الجد"
                              expanded
                            ></b-input>
                          </b-field>
                        </div>

                        <div class="column is-6">
                          <b-field
                            label="إسم العائلة"
                            :type="{ 'is-danger': errors.has('familyName') }"
                            :message="errors.first('familyName')"
                          >
                            <b-input
                              type="text"
                              size="is-medium"
                              custom-class="has-text-centerd"
                              v-model="requestInfoBasicData.familyName"
                              name="familyName"
                              v-validate="'required'"
                              placeholder="ادخل إسم العائلة"
                              expanded
                            ></b-input>
                          </b-field>
                        </div>
                      </div>
                      <div class="columns">
                        <div class="column is-6">
                          <b-field
                            label="الرقم الوطني"
                            :type="{ 'is-danger': errors.has('nid') }"
                            :message="errors.first('nid')"
                          >
                            <b-input
                              type="text"
                              size="is-medium"
                              custom-class="has-text-centerd"
                              v-model="requestInfoBasicData.nid"
                              name="nid"
                              v-validate="{
                                required: true,
                                numeric: true,
                                max: 12,
                                min: 12,
                              }"
                              placeholder="ادخل الرقم الوطني"
                              expanded
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label="رقم الموبايل المربوط بالرقم الوطني "
                            :type="{ 'is-danger': errors.has('nidMobileNo') }"
                            :message="errors.first('nidMobileNo')"
                          >
                            <b-input
                              type="text"
                              size="is-medium"
                              custom-class="has-text-centerd"
                              v-model="requestInfoBasicData.nidMobileNo"
                              name="nidMobileNo"
                              v-validate="{
                                required: true,
                                numeric: true,
                                regex: /^09\d{8}$/,
                              }"
                              placeholder="ادخل رقم الموبايل"
                              expanded
                            ></b-input>
                          </b-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-20" v-if="userData != null">
                    <a
                      class="button secondary-btn btn-align modal-dismiss is-bold is-medium"
                      style="margin-left: 10px; margin-right: 10px"
                      @click="validateBeforeSubmit"
                    >
                      <b>أوافق على المعلومات الشخصية</b>
                    </a>
                    <a
                      class="button danger-btn btn-align modal-dismiss is-bold is-medium"
                      style="margin-left: 10px; margin-right: 10px"
                      @click="userUpdateInfoModal"
                    >
                      <b>إلغاء</b>
                    </a>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
        <!-- <button class="modal-close is-large"></button> -->
      </div>
      <div
        id="success-overlay"
        class="modal modal-lg modal-success"
        v-bind:class="{
          'is-active': alertBoxError,
        }"
      >
        <div class="modal-background scaleInCircle"></div>
        <div class="modal-content scaleIn">
          <div class="flex-card simple-shadow">
            <header class="modal-card-head">
              <p class="modal-card-title p-20">
                <b>تنبيه !</b>
              </p>
            </header>
            <div class="card-body">
              <div class="content">
                <section class="modal-card-body" style="padding: 35px">
                  <div class="animated preFadeInUp fadeInUp">
                    <div>{{ alertBoxMessage }}</div>
                  </div>
                </section>
              </div>
              <div class="mt-20">
                <a
                  class="button danger-btn btn-align modal-dismiss is-bold is-medium"
                  style="margin: 10px"
                  @click="alertBoxFuncError"
                >
                  <b> موافق</b>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- <button class="modal-close is-large"></button> -->
      </div>
      <!-- Title -->

      <div class="columns has-text-centered is-centered" v-if="loading">
        <loading
          font-size="20"
          line-fg-color="var(--primary-color)"
          size="massive"
          class="margin-100"
          text-fg-color="#2d3f51"
          message="الرجاء الإنتظار"
        />
      </div>
      <div v-else>
        <div class="section-title-wrapper has-text-centered mt-40">
          <div class="clean-bg-symbol">
            <i class="sl sl-icon-user"></i>
          </div>
          <div>
            <h6
              class="clean-section-title has-text-black has-text-weight-bold is-small"
            >
              الحساب
            </h6>
            <h2
              class="subtitle is-5 pt-10 pb-10 has-text-black has-text-weight-bold"
            >
              معلومات الحساب
            </h2>
          </div>
        </div>
        <div v-if="matchInfo != null">
          <div v-if="matchInfo.view_messages == true">
            <div class="columns is-vcentered is-multiline pt-30">
              <div class="column is-6 is-offset-3">
                <div class="columns has-same-height">
                  <div class="column">
                    <div class="card">
                      <div class="card-content">
                        <div class="content">
                          <div class="pt-10 pb-10">
                            الحالة :
                            <span
                              :style="{
                                color:
                                  matchInfo.matching_status === 'matched'
                                    ? 'green'
                                    : 'red',
                              }"
                            >
                              {{ matchDic[matchInfo.matching_status] }}
                            </span>
                          </div>

                          <b-message
                            title="تنبيه"
                            v-if="matchInfo.general_message.trim() !== ''"
                            :closable="false"
                            :type="'is-warning'"
                            class="pb-5 pt-20"
                          >
                            {{ matchInfo.general_message }}</b-message
                          >
                          <b-message
                            title="تنبيه"
                            v-if="matchInfo.customer_message.trim() !== ''"
                            :closable="false"
                            :type="'is-warning'"
                            class="pb-5 pt-20"
                          >
                            {{ matchInfo.customer_message }}</b-message
                          >
                        </div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="columns is-vcentered is-multiline pt-30">
          <div class="column is-6 is-offset-3">
            <div class="columns has-same-height">
              <div class="column">
                <div class="card">
                  <div class="card-content">
                    <div class="content">
                      <table class="table-profile">
                        <tbody>
                          <tr>
                            <th colspan="1"></th>
                            <th colspan="2"></th>
                          </tr>

                          <tr>
                            <td>رقم الزبون في الصحارى أونلاين:</td>
                            <td>{{ userid }}</td>
                          </tr>
                          <tr>
                            <td>رقم الحساب:</td>
                            <td>{{ info.MainAccountNo }}</td>
                          </tr>
                          <tr>
                            <td>رقم IBAN:</td>
                            <td>{{ info.iban }}</td>
                          </tr>
                          <tr>
                            <td>الاسم:</td>
                            <td>
                              {{ info.FirstName }} {{ info.FatherName }}
                              {{ info.GrandFatherName }} {{ info.FamilyName }}
                            </td>
                          </tr>
                          <tr>
                            <td>الرقم الوطني:</td>
                            <td>{{ info.NID }}</td>
                          </tr>
                          <tr>
                            <td>رقم الجواز السفر:</td>
                            <td>{{ info.PassportNO }}</td>
                          </tr>
                          <tr>
                            <td>تاريخ انتهاء جواز السفر:</td>
                            <td>{{ info.PassportDateOfExpiration }}</td>
                          </tr>
                          <tr>
                            <td>رقم هاتف الصحارى أونلاين:</td>
                            <td>{{ info.MobileNo }}</td>
                          </tr>
                          <tr>
                            <td>رقم الهاتف المربوط مع الرقم الوطني:</td>
                            <td>{{ info.NidMobileNo }}</td>
                          </tr>
                          <tr>
                            <td>البريد الالكتروني:</td>
                            <td>{{ info.Email }}</td>
                          </tr>

                          <tr>
                            <td>كلمة السر:</td>
                            <td>
                              <router-link to="/profile/changepassword">
                                <a
                                  class="button btn primary-btn is-rounded is-shadowless is-medium"
                                >
                                  <b>تغير</b>
                                </a>
                              </router-link>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <a
                        class="button secondary-btn btn-align modal-dismiss is-bold is-medium"
                        style="margin: 10px"
                        @click="userUpdateInfoModal"
                      >
                        <b> تعديل البيانات</b>
                      </a>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";
import { async } from "q";
moment.locale("ar");

export default {
  name: "profile",

  data() {
    return {
      info: null,
      loading: false,
      userid: null,
      alertBoxMessage: null,
      alertBoxError: false,
      userDataActiveModal: false,
      requestInfoBasicData: {
        id: null,
        firstName: null,
        fatherName: null,
        grandFatherName: null,
        familyName: null,
        passportNo: null,
        nID: null,
        // DOB: null,
        nidMobileNo: null,
        passportExpirationDate: null,
      },
      matchInfo: null,
      matchDic: {
        pending: "في انتظار المطابقة",
        matched: "مطابق",
        unmatched: "غير مطابق",
      },
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isAgreeKycUpdate();
          return;
        }
      });
    },
    alertBoxFuncError() {
      // this.$router.push("/");
      this.alertBoxError = false;
    },
    isAgreeKycUpdate() {
      axios
        .post("/customer/updatekycbycustomer", this.requestInfoBasicData)
        .then((response) => {
          if (response.data.status === "success") {
            this.getUserData();
            this.userDataActiveModal = false;
          } else if (response.data.status === "fail") {
            this.userDataActiveModal = false;
            this.alertBoxMessage = response.data.message;
            this.alertBoxError = true;
            console.log("fails");
          }
        })
        .catch((error) => {
          this.isLoading = !this.isLoading;
        });
    },
    userUpdateInfoModal() {
      this.userDataActiveModal = !this.userDataActiveModal;
    },
    getUserData() {
      var user = JSON.parse(localStorage.getItem("user"));

      axios
        .get("/customer/basicData/" + user[1])
        .then((response) => {
          this.$root.kick(response.data.message);
          this.info = response.data.result;
          this.userid = user[1];
          this.loading = false;
          this.userData = response.data.result;

          this.requestInfoBasicData = {
            id: this.userData.id,
            firstName: this.userData.FirstName,
            fatherName: this.userData.FatherName,
            grandFatherName: this.userData.GrandFatherName,
            familyName: this.userData.FamilyName,
            passportNo: this.userData.PassportNO,
            nid: this.userData.NID,
            nidMobileNo: this.userData.NidMobileNo,
            passportExpirationDate: this.userData.PassportDateOfExpiration,
          };
        })
        .catch((error) => {
          // this.$router.push('/');
        });
    },
  },
  created() {
    moment.locale("en");
    this.$validator.localize("ar", {
      messages: arabic.messages,
      attributes: {
        firstName: "الإسم الأول",
        fatherName: "إسم الأب",
        grandFatherName: "إسم الجد",
        familyName: "إسم العائلة",
        passportNo: "رقم جواز السفر",
        nid: "الرقم الوطني",
        // DOB: "تاريخ الميلاد",
        nidMobileNo: "رقم الموبايل",
        passportExpirationDate: "تاريخ انتهاء صلاحية جواز السفر",
      },
      custom: {
        nidMobileNo: {
          regex: "رقم الهاتف يجب ان يبدا ب(09) ويليه ثمان ارقام ",
        },
      },
    });
    this.loading = true;
    var user = JSON.parse(localStorage.getItem("user"));

    axios
      .get("/customer/basicData/" + user[1])
      .then((response) => {
        this.$root.kick(response.data.message);
        this.info = response.data.result;
        this.userid = user[1];
        this.loading = false;
        this.userData = response.data.result;

        this.requestInfoBasicData = {
          id: this.userData.id,
          firstName: this.userData.FirstName,
          fatherName: this.userData.FatherName,
          grandFatherName: this.userData.GrandFatherName,
          familyName: this.userData.FamilyName,
          passportNo: this.userData.PassportNO,
          nid: this.userData.NID,
          // DOB: this.userData.DOB,
          nidMobileNo: this.userData.NidMobileNo,
          passportExpirationDate: this.userData.PassportDateOfExpiration,
        };
      })
      .catch((error) => {
        // this.$router.push('/');
      });

    axios
      .get("/customer/getKycMessages/" + user[1])
      .then((response) => {
        this.matchInfo = response.data;
      })
      .catch((error) => {
        // this.$router.push('/');
      });
  },
};
</script>
